"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBEXTENSION = void 0;
exports.WEBEXTENSION = {
    USB_PERMISSIONS_BROADCAST: 'usb-permissions',
    USB_PERMISSIONS_INIT: 'usb-permissions-init',
    USB_PERMISSIONS_CLOSE: 'usb-permissions-close',
    USB_PERMISSIONS_FINISHED: 'usb-permissions-finished',
    CHANNEL_HANDSHAKE_CONFIRM: 'channel-handshake-confirm',
};
//# sourceMappingURL=webextension.js.map